import axios from 'axios';
import i18n from '../../../i18next';

import {
    LOAD_RESTAURANT_INSIGHT,
    LOAD_RESTAURANT_INSIGHT_DISABLED,
    LOADING,
    ENABLE_DISABLE_RESTAURANT_INSIGHT,
    LOAD_RESTAURANT_INSIGHT_PRODUCT_SUMMARY_SEARCH,
    LOAD_RESTAURANT_INSIGHT_PROMOTION_SUMMARY_SEARCH,
    LOAD_RESTAURANT_INSIGHT_PROMOCODES_SUMMARY_SEARCH,
    LOAD_RESTAURANT_INSIGHT_HOURLY_ORDER_FREQUENCY_SEARCH,
    LOAD_RESTAURANT_INSIGHT_DAILY_ORDER_FREQUENCY_SEARCH,
    LOAD_RESTAURANT_INSIGHT_ORDER_TYPE_SEARCH,
    LOAD_RESTAURANT_INSIGHT_SOURCE_TYPE_SEARCH,
    LOAD_RESTAURANT_INSIGHT_PAYMENT_TYPE_SEARCH
} from "../../types";
import { SERVER_URL, DEFAULT_PAGE_SIZE } from "../../../utils/Constants";
import MessageUtils from "../../../utils/MessageUtils";

export const loadRestaurantInsight = (restaurantId) => {
    return (dispatch, getState) => {

        const url = `${SERVER_URL}/advanced-reporting/${restaurantId}/restaurant-summary`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadRestaurantInsightSuccess(dispatch, response))
            .catch(() => loadRestaurantInsightFail(dispatch))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadRestaurantInsightSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_RESTAURANT_INSIGHT, payload: response.data })
};

const loadRestaurantInsightFail = dispatch => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_RESTAURANT_INSIGHT_DISABLED })
}

export const enableDisableRestaurantInsight = (restaurantId, isEnableAction) => {
    return (dispatch, getState) => {

        const url = `${SERVER_URL}/advanced-reporting/enable?restaurantId=${restaurantId}&enable=${isEnableAction}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.put(url, {}, header)
            .then(response => enableDisableRestaurantInsightSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:restaurantInsightActions.enableDisableInsightFail')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }
};

const enableDisableRestaurantInsightSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: ENABLE_DISABLE_RESTAURANT_INSIGHT, payload: response.data })
};

export const loadRestaurantInsightProductSummarySearch = (restaurantId, fromDate,
    toDate, page, orderTypeId, paymentTypeId, productName) => {

    return (dispatch, getState) => {

        let fromDateParam = '';
        let toDateParam = '';
        let orderTypeIdParam = '';
        let paymentTypeIdParam = '';
        let productNameParam = '';
        let restaurantIdParam = `restaurantId=${restaurantId}`;
        let pageParam = `&page=${page}`;
        let sizeParam = `&size=${DEFAULT_PAGE_SIZE}`;

        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }
        if (orderTypeId && orderTypeId !== '') {
            orderTypeIdParam = `&orderTypeId=${orderTypeId}`
        }
        if (paymentTypeId && paymentTypeId !== '') {
            paymentTypeIdParam = `&paymentTypeId=${paymentTypeId}`
        }
        if (productName && productName !== '') {
            productNameParam = `&name=${productName}`
        }

        const url = `${SERVER_URL}/advanced-reporting/summarized-product-search?${restaurantIdParam}${pageParam}${sizeParam}${fromDateParam}${toDateParam}${orderTypeIdParam}${paymentTypeIdParam}${productNameParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadRestaurantInsightProductSummarySearchSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightProductSummarySearchFail')))
            .finally(dispatch({ type: LOADING, payload: false }));
        
    }
}

const loadRestaurantInsightProductSummarySearchSuccess = (dispatch, response) => {
    dispatch({ type: LOAD_RESTAURANT_INSIGHT_PRODUCT_SUMMARY_SEARCH, payload: response.data })
};

export const loadRestaurantInsightPromotionSummarySearch = (restaurantId, page, promotionId, promotionName, fromDate, toDate, orderTypeId, paymentTypeId) => {
    return (dispatch, getState) => {

        let promotionIdParam = '';
        let nameParam = '';
        let restaurantIdParam = `&restaurantId=${restaurantId}`;
        let pageParam = `page=${page}`;
        let sizeParam = `&size=${DEFAULT_PAGE_SIZE}`;
        let fromDateParam = '';
        let toDateParam = '';
        let orderTypeIdParam = '';
        let paymentTypeIdParam = '';

        //If promotionId is set, promotionName must be null
        if (promotionId && promotionId !== '') {
            promotionIdParam = `&promotionId=${promotionId}`
        } else if (promotionName && promotionName !== '') {
            nameParam = `&name=${promotionName}`
        }
        if (fromDate && fromDate !== '') {
            fromDateParam = `&startDate=${fromDate}`
        }
        if (toDate && toDate !== '') {
            toDateParam = `&endDate=${toDate}`
        }
        if (orderTypeId && orderTypeId !== '') {
            orderTypeIdParam = `&orderTypeId=${orderTypeId}`
        }
        if (paymentTypeId && paymentTypeId !== '') {
            paymentTypeIdParam = `&paymentTypeId=${paymentTypeId}`
        }

        const url = `${SERVER_URL}/advanced-reporting/summarized-promotion-search?${pageParam}${restaurantIdParam}${sizeParam}${promotionIdParam}${nameParam}${fromDateParam}${toDateParam}${orderTypeIdParam}${paymentTypeIdParam}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        dispatch({ type: LOADING, payload: true });

        axios.get(url, header)
            .then(response => loadRestaurantInsightPromotionSummarySearchSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadPromotionSummarySearchFail')))
            .finally(dispatch({ type: LOADING, payload: false }));
    }
};

const loadRestaurantInsightPromotionSummarySearchSuccess = (dispatch, response) => {
    dispatch({ type: LOAD_RESTAURANT_INSIGHT_PROMOTION_SUMMARY_SEARCH, payload: response.data })
};

export const loadRestaurantInsightPromoCodesSummarySearch = (page, restaurantId, fromDate,
    toDate, paymentTypeId, orderTypeId, discountTypeId, promotionId, promotionName, promoCodeName ) => {
        return (dispatch, getState) => {

            let fromDateParam = '';
            let toDateParam = '';
            let orderTypeIdParam = '';
            let paymentTypeIdParam = '';
            let discountTypeIdParam = '';
            let restaurantIdParam = `&restaurantId=${restaurantId}`;
            let pageParam = `page=${page}`;
            let sizeParam = `&size=${DEFAULT_PAGE_SIZE}`;
            let promotionIdParam = '';
            let promotioNameParam = '';
            let promoCodeNameParam = '';
    
             //If promotionId is set, promotionName must be null
            if (promotionId && promotionId !== '') {
                promotionIdParam = `&promotionId=${promotionId}`
            } else if (promotionName && promotionName !== '') {
                promotioNameParam = `&name=${promotionName}`
            }
            if (fromDate && fromDate !== '') {
                fromDateParam = `&startDate=${fromDate}`
            }
            if (toDate && toDate !== '') {
                toDateParam = `&endDate=${toDate}`
            }
            if (orderTypeId && orderTypeId !== '') {
                orderTypeIdParam = `&orderTypeId=${orderTypeId}`
            }
            if (paymentTypeId && paymentTypeId !== '') {
                paymentTypeIdParam = `&paymentTypeId=${paymentTypeId}`
            }
            if (discountTypeId && discountTypeId !== '') {
                discountTypeIdParam = `&discountTypeId=${discountTypeId}`
            }
            if (promoCodeName && promoCodeName !== '') {
                promoCodeNameParam = `&promoCode=${promoCodeName}`
            }
    
            const url = `${SERVER_URL}/advanced-reporting/summarized-promo-code-search?${pageParam}${restaurantIdParam}${sizeParam}${fromDateParam}${toDateParam}${paymentTypeIdParam}${orderTypeIdParam}${discountTypeIdParam}${promotionIdParam}${promotioNameParam}${promoCodeNameParam}`;
            const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };
    
            dispatch({ type: LOADING, payload: true });
    
            axios.get(url, header)
                .then(response => loadRestaurantInsightPromoCodesSummarySearchSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(
                    dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightProductSummarySearchFail')))
                .finally(dispatch({ type: LOADING, payload: false }));
            
        }
    };

    const loadRestaurantInsightPromoCodesSummarySearchSuccess = (dispatch, response) => {
        dispatch({ type: LOAD_RESTAURANT_INSIGHT_PROMOCODES_SUMMARY_SEARCH, payload: response.data })
    };

    export const loadRestaurantInsightHourlyStatisticSearch = (restaurantId, fromDate, toDate) => {
        return (dispatch, getState) => {

            let fromDateParam = '';
            let toDateParam = '';
    
            if (fromDate && fromDate !== '') {
                fromDateParam = `&startDate=${fromDate}`
            }
            if (toDate && toDate !== '') {
                toDateParam = `&endDate=${toDate}`
            }
    
            const url = `${SERVER_URL}/advanced-reporting/restaurant-hourly-statistic-search?restaurantId=${restaurantId}${fromDateParam}${toDateParam}`;
            const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };
    
            dispatch({ type: LOADING, payload: true });
    
            axios.get(url, header)
                .then(response => loadRestaurantInsightHourlyStatisticSearchSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(
                    dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightOrderFrequencySearchFail')))
                .finally(dispatch({ type: LOADING, payload: false }));
        }
    };

    const loadRestaurantInsightHourlyStatisticSearchSuccess = (dispatch, response) => {
        dispatch({ type: LOAD_RESTAURANT_INSIGHT_HOURLY_ORDER_FREQUENCY_SEARCH, payload: response.data })
    };

    export const loadRestaurantInsightDailyOrderFrequencySearch = (restaurantId, fromDate, toDate) => {
        return (dispatch, getState) => {
    
            let fromDateParam = '';
            let toDateParam = '';
    
            if (fromDate && fromDate !== '') {
                fromDateParam = `&startDate=${fromDate}`
            }
            if (toDate && toDate !== '') {
                toDateParam = `&endDate=${toDate}`
            }
    
            const url = `${SERVER_URL}/advanced-reporting/restaurant-daily-statistic-search?restaurantId=${restaurantId}${fromDateParam}${toDateParam}`;
            const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };
    
            dispatch({ type: LOADING, payload: true });
    
            axios.get(url, header)
                .then(response => loadRestaurantInsightDailyOrderFrequencySearchSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(
                    dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightOrderFrequencySearchFail')))
                .finally(dispatch({ type: LOADING, payload: false }));
        }
    };
    
    const loadRestaurantInsightDailyOrderFrequencySearchSuccess = (dispatch, response) => {
        dispatch({ type: LOAD_RESTAURANT_INSIGHT_DAILY_ORDER_FREQUENCY_SEARCH, payload: response.data })
    };

    export const loadRestaurantInsightOrderSearchSummary = (restaurantId, fromDate, toDate) => {
        return (dispatch, getState) => {
    
            let fromDateParam = '';
            let toDateParam = '';
    
            if (fromDate && fromDate !== '') {
                fromDateParam = `&startDate=${fromDate}`
            }
            if (toDate && toDate !== '') {
                toDateParam = `&endDate=${toDate}`
            }
    
            const url = `${SERVER_URL}/advanced-reporting/restaurant-order-type-search?restaurantId=${restaurantId}${fromDateParam}${toDateParam}`;
            const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };
    
            dispatch({ type: LOADING, payload: true });
    
            axios.get(url, header)
                .then(response => loadRestaurantInsightOrderSearchSummarySuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(
                    dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightOrderSearchFail')))
                .finally(dispatch({ type: LOADING, payload: false }));
        }
    };
    
    const loadRestaurantInsightOrderSearchSummarySuccess = (dispatch, response) => {
        dispatch({ type: LOAD_RESTAURANT_INSIGHT_ORDER_TYPE_SEARCH, payload: response.data })
    };

    export const loadRestaurantInsightSourceSearchSummary = (restaurantId, fromDate, toDate) => {
        return (dispatch, getState) => {
    
            let fromDateParam = '';
            let toDateParam = '';
    
            if (fromDate && fromDate !== '') {
                fromDateParam = `&startDate=${fromDate}`
            }
            if (toDate && toDate !== '') {
                toDateParam = `&endDate=${toDate}`
            }
    
            const url = `${SERVER_URL}/advanced-reporting/restaurant-source-type-search?restaurantId=${restaurantId}${fromDateParam}${toDateParam}`;
            const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };
    
            dispatch({ type: LOADING, payload: true });
    
            axios.get(url, header)
                .then(response => loadRestaurantInsightSourceSearchSummarySuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(
                    dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightSourceSearchFail')))
                .finally(dispatch({ type: LOADING, payload: false }));
        }
    };
    
    const loadRestaurantInsightSourceSearchSummarySuccess = (dispatch, response) => {
        dispatch({ type: LOAD_RESTAURANT_INSIGHT_SOURCE_TYPE_SEARCH, payload: response.data })
    };

    export const loadRestaurantInsightPaymentSearchSummary = (restaurantId, fromDate, toDate) => {
        return (dispatch, getState) => {
    
            let fromDateParam = '';
            let toDateParam = '';
    
            if (fromDate && fromDate !== '') {
                fromDateParam = `&startDate=${fromDate}`
            }
            if (toDate && toDate !== '') {
                toDateParam = `&endDate=${toDate}`
            }
    
            const url = `${SERVER_URL}/advanced-reporting/restaurant-payment-type-search?restaurantId=${restaurantId}${fromDateParam}${toDateParam}`;
            const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };
    
            dispatch({ type: LOADING, payload: true });
    
            axios.get(url, header)
                .then(response => loadRestaurantInsightPaymentSearchSummarySuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(
                    dispatch, error.response.data, i18n.t('actions:customerInsightActions.loadCustomerInsightPaymentSearchFail')))
                .finally(dispatch({ type: LOADING, payload: false }));
        }
    };
    
    const loadRestaurantInsightPaymentSearchSummarySuccess = (dispatch, response) => {
        dispatch({ type: LOAD_RESTAURANT_INSIGHT_PAYMENT_TYPE_SEARCH, payload: response.data })
    };


// WEBPACK FOOTER //
// ./src/actions/restaurants/restaurantInsight/RestaurantInsightAction.js